import { useMutation } from '@tanstack/react-query';

import { useToaster } from '@components/toaster';

import { api } from 'api';
import { useInvalidateApplicantsAfterReindex } from 'hooks/use-invalidate-applicants-after-reindex';
import { useStore } from 'models/Provider';

type Props = {
  applicationId: number;
};

export function useUnRetractApplication() {
  const { applicationStore, t } = useStore();
  const { showSuccess, showError } = useToaster();

  const invalidateApplicantsAfterReindex = useInvalidateApplicantsAfterReindex();

  return useMutation((props: Props) => api.applications.unRetract(props.applicationId), {
    onSuccess: (_, { applicationId }) => {
      showSuccess(t('application.unretract.success'));
      invalidateApplicantsAfterReindex();
      applicationStore.unRetract(applicationId);
    },
    onError: () => {
      showError(t('application.unretract.error'));
    },
  });
}
